import log from '@/lib/logger';
import type { AppDispatch, RootState } from '@/store';
import type { UnknownAction } from '@reduxjs/toolkit';
import { getFleets } from 'services/fleets';
import type { Fleet } from 'types/swagger';

enum FleetsActionTypes {
  SET_FLEETS = 'SET_FLEETS',
  SET_IS_FETCHING_FLEETS = 'SET_IS_FETCHING_FLEETS',
}

type FleetsAction = {
  type: FleetsActionTypes;
  payload: any;
};

export const setFleets = (fleets: Fleet[]): FleetsAction => ({
  type: FleetsActionTypes.SET_FLEETS,
  payload: fleets,
});

export const setIsFetchingFleets = (isFetching: boolean): FleetsAction => ({
  type: FleetsActionTypes.SET_IS_FETCHING_FLEETS,
  payload: isFetching,
});

type FleetsState = {
  fleets: {
    fleets: Fleet[];
  };

  isFetchingFleets: boolean;
};

const INIT_STATE: FleetsState = {
  fleets: {
    fleets: [],
  },
  isFetchingFleets: false,
};

export default function fleetsReducer(state = INIT_STATE, action: UnknownAction): FleetsState {
  const { type, payload } = action;

  switch (type) {
    case FleetsActionTypes.SET_FLEETS: {
      return {
        ...state,
        fleets: {
          ...state.fleets,
          fleets: payload as Fleet[],
        },
      };
    }
    default:
      return state;
  }
}

export const fetchFleets = () => async (dispatch: AppDispatch) => {
  dispatch(setIsFetchingFleets(true));

  return getFleets()
    .then((res) => {
      if (res.data.results.length) {
        dispatch(setFleets(res.data.results));
        dispatch(setIsFetchingFleets(false));
        return res;
      }
      return res;
    })
    .catch((err) => {
      log.error(err);
      return err;
    })
    .finally(() => dispatch(setIsFetchingFleets(false)));
};

export const selectFleets = (state: RootState) => state.fleets.fleets.fleets;
export const selectIsFetchingFleets = (state: RootState) => state.fleets.isFetchingFleets;
